import {useNativeAuth} from '../modules/auth/native/NativeAuthProvider';

export const useClientName = (): string => {
  const {claims} = useNativeAuth();

  return (claims?.preferred_username as string) ?? '';
};
